export const MOBILE_LINK_CHOICE_KEY = "WALLETCONNECT_DEEPLINK_CHOICE";
export const mobileLinkChoiceKey = MOBILE_LINK_CHOICE_KEY;
//# sourceMappingURL=mobile.js.map